import React, { useEffect } from 'react';

const CustomCursor = () => {
  useEffect(() => {
    const cursor = document.createElement('div');
    const cursorFollower = document.createElement('div');

    cursor.className = 'cursor';
    cursorFollower.className = 'cursor-follower';

    document.body.appendChild(cursor);
    document.body.appendChild(cursorFollower);

    let mouseX = 0;
    let mouseY = 0;
    let cursorX = 0;
    let cursorY = 0;
    let followerX = 0;
    let followerY = 0;
    let isExpanded = false;

    // Smooth easing function
    const lerp = (start, end, amount) => {
      return (1 - amount) * start + amount * end;
    };

    const moveCursor = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    const animate = () => {
      // Smooth animation for main cursor
      cursorX = lerp(cursorX, mouseX, 0.15);
      cursorY = lerp(cursorY, mouseY, 0.15);

      // Smooth animation for follower with more lag
      followerX = lerp(followerX, mouseX, 0.08);
      followerY = lerp(followerY, mouseY, 0.08);

      cursor.style.left = cursorX + 'px';
      cursor.style.top = cursorY + 'px';
      cursorFollower.style.left = followerX + 'px';
      cursorFollower.style.top = followerY + 'px';

      requestAnimationFrame(animate);
    };

    const expandCursor = () => {
      if (!isExpanded) {
        cursor.classList.add('expand');
        cursorFollower.classList.add('expand');
        isExpanded = true;
      }
    };

    const shrinkCursor = () => {
      if (isExpanded) {
        cursor.classList.remove('expand');
        cursorFollower.classList.remove('expand');
        isExpanded = false;
      }
    };

    const addHoverListeners = () => {
      const clickableElements = document.querySelectorAll(
        'a, button, .btn, input, textarea, select, [role="button"], .nav-link, .dropdown-link, .gallery-item'
      );
      clickableElements.forEach((el) => {
        el.addEventListener('mouseenter', expandCursor);
        el.addEventListener('mouseleave', shrinkCursor);
      });
      return clickableElements;
    };

    document.addEventListener('mousemove', moveCursor);
    let clickableElements = addHoverListeners();
    animate();

    // Re-add listeners when DOM changes (for dynamically loaded content)
    const observer = new MutationObserver(() => {
      clickableElements.forEach((el) => {
        el.removeEventListener('mouseenter', expandCursor);
        el.removeEventListener('mouseleave', shrinkCursor);
      });
      clickableElements = addHoverListeners();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Cleanup
    return () => {
      document.removeEventListener('mousemove', moveCursor);
      clickableElements.forEach((el) => {
        el.removeEventListener('mouseenter', expandCursor);
        el.removeEventListener('mouseleave', shrinkCursor);
      });
      observer.disconnect();
      if (cursor.parentNode) cursor.remove();
      if (cursorFollower.parentNode) cursorFollower.remove();
    };
  }, []);

  return null;
};

export default CustomCursor;
